import {
  mockCarouselList,
  mockCustomerDppmList,
  mockCustomerPassRatioList,
  mockDamageRatioList,
  mockFailureTimesList,
  mockFunctionDppmList,
  mockAppearanceDppmList,
  mockHetPlantDict,
  mockLarChartList,
  mockModuleDict
} from '@/mock/mockData'

function ok(data) {
  return Promise.resolve({ success: true, data })
}

// admin url
export function getCustomerDpmmData(plantSelected, createdTime) {
  return ok({ list: mockCustomerDppmList(createdTime) })
}

// 客户审核通过率 (%)
export function getCustomerPassRatioData(plantSelected, createdTime) {
  return ok({ list: mockCustomerPassRatioList(createdTime) })
}

// 送样失败次数/小批失败次数(Case)
export function getFailureTimesData(plantSelected, createdTime) {
  return ok({ list: mockFailureTimesList(createdTime) })
}

// QA外观DPPM
export function getAppearanceDppmData(plantSelected, createdTime) {
  return ok({ list: mockAppearanceDppmList(createdTime) })
}

// QA功能DPPM
export function getFunctionDppmData(plantSelected, createdTime) {
  return ok({ list: mockFunctionDppmList(createdTime) })
}

// 来料批次合格率(LAR) (%)
export function getLarChartData(plantSelected, createdTime) {
  return ok({ list: mockLarChartList(createdTime) })
}

// 质量成本损失率(%)
export function getDamageChartData(plantSelected, createdTime) {
  return ok({ list: mockDamageRatioList(createdTime) })
}

// 获取het工厂列表
export function getHetPlantList() {
  return ok(mockHetPlantDict())
}

// 获取module列表
export function getModuleList() {
  return ok(mockModuleDict())
}

// 获取文档
export function getDocumentByPath(path) {
  return ok({ path: 'https://example.com/mock-file.pdf' })
}

export function getCarouselList() {
  return ok({ list: mockCarouselList() })
}
